import api from '../axios/axiosInstance';

export interface SubscriptionModule {
  _id: string;
  moduleId: string;
  name: string;
  description: string;
  type: string;
  isActive: boolean;
  version: number;
  dependencies: string[];
  pricing: {
    monthly: number;
    yearly: number;
    currency: string;
    trialDays: number;
  };
  features: string[];
  permissions: string[];
  createdAt: string;
  updatedAt: string;
}

export const getSubscriptionModules = async (): Promise<SubscriptionModule[]> => {
  const response = await api.get('/module');
  return response.data;
};
